import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Roster } from '../../models/roster';
import { CommonModule } from '@angular/common';
import { genreColorClass } from '../../utils/genre-colors';

@Component({
  selector: 'app-creator-tile',
  imports: [CommonModule],
  templateUrl: './creator-tile.component.html',
  styleUrl: './creator-tile.component.css'
})
export class CreatorTileComponent {
  @Input() roster!: Partial<Roster>;
  @Input() removable = false;
  @Output() remove = new EventEmitter<string>();

  onRemoveClick(event: Event): void {
    event.stopPropagation();
    if (this.roster.id) {
      this.remove.emit(this.roster.id);
    }
  }

  navigateToMediaKit(): void {
    if (this.roster.id) {
      window.open('/mediakit/' + this.roster.id, '_blank');
    }
  }

  get primaryImageSrc(): string {
    return '/' + (this.roster.id || '').substring(0, 8) + '_a.webp';
  }

  get secondaryImageSrc(): string {
    return '/' + (this.roster.id || '').substring(0, 8) + '_b.webp';
  }

  get handlesLine(): string {
    const handle =
      this.roster.tiktokHandle ||
      this.roster.instagramHandle ||
      this.roster.youtubeHandle ||
      '';
    if (!handle) return '';
    return handle.startsWith('@') ? handle : '@' + handle;
  }

  get genreTags(): string[] {
    if (!this.roster.genre) return [];
    return this.roster.genre.split('\n').map(g => g.trim()).filter(g => g.length > 0);
  }

  genreColorClass = genreColorClass;

  get statColumns(): number {
    let count = 0;
    if (this.roster.instagramFollowers) count++;
    if (this.roster.tikTokFollowers) count++;
    if (this.roster.youtubeFollowers) count++;
    return count || 1;
  }

  secondaryImageFailed = false;

  onImageError(event: Event): void {
    (event.target as HTMLElement).style.display = 'none';
  }

  onSecondaryImageError(event: Event): void {
    (event.target as HTMLElement).style.display = 'none';
    this.secondaryImageFailed = true;
  }

  formatFollowers(value?: string): string {
    if (!value) return '';
    if (/[KMBkmb]/.test(value)) return value;
    const num = parseFloat(value);
    if (isNaN(num)) return value;
    if (num >= 1_000_000) return (num / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
    if (num >= 1_000) return Math.round(num / 1_000) + 'K';
    return num.toString();
  }
}
